import { render, staticRenderFns } from "./Hindex.vue?vue&type=template&id=2c54a464"
import script from "./Hindex.vue?vue&type=script&lang=js"
export * from "./Hindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports